<ng-container *ngIf="company$ | async as company; else loader">
  <div class="flex ms-medium-b">
    <div class="flex flex-1 flex--middle ps-xxsmall-y">
      <h4>{{ 'CORPORATE.corporatePortal.corporateDetails.header' | finLocalization }}</h4>
    </div>
    <ng-container *ngIf="isAdmin$ | async">
      <div class="dn-mobile">
        <fcom-button
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [icon]="{
            name: SvgLibraryIcon.EDIT,
            position: IconPosition.LEFT,
          }"
          [text]="'CORPORATE.corporatePortal.editDetails' | finLocalization"
          [disabled]="updating"
          [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
          (clickBtn)="editCompanyDetails()"
        ></fcom-button>
      </div>
      <div class="dn-tablet-up">
        <fcom-icon-button
          [icon]="{ name: SvgLibraryIcon.EDIT }"
          [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [size]="IconButtonSize.MEDIUM"
          [title]="'CORPORATE.corporatePortal.editDetails' | finLocalization"
          [aria]="{ label: 'CORPORATE.corporatePortal.editDetails' | finLocalization }"
          (clickBtn)="editCompanyDetails()"
        >
        </fcom-icon-button>
      </div>
    </ng-container>
  </div>
  <div class="ms-xlarge-b">
    <fcom-table
      class="font-body-2"
      [rowData]="companyDetailsData$ | async"
      [cellTemplate]="itemTemplate"
      [mobileTemplate]="mobileTemplate"
      [headers]="companyDetailsHeaders"
      [usePagination]="false"
      [loading]="updating && editFormType === EditFormType.COMPANY_DETAILS"
      [caption]="'CORPORATE.corporatePortal.corporateDetails.header' | finLocalization"
    ></fcom-table>
  </div>

  <div class="flex ms-medium-b">
    <div class="flex flex-1 flex--middle">
      <h4>{{ 'CORPORATE.corporatePortal.corporateDetails.contactPersons' | finLocalization }}</h4>
    </div>
    <ng-container *ngIf="isAdmin$ | async">
      <div class="dn-mobile">
        <fcom-button
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [icon]="{
            name: SvgLibraryIcon.EDIT,
            position: IconPosition.LEFT,
          }"
          [text]="'CORPORATE.corporatePortal.editDetails' | finLocalization"
          [disabled]="updating"
          [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
          (clickBtn)="editContactPersons()"
        ></fcom-button>
      </div>
      <div class="dn-tablet-up">
        <fcom-icon-button
          [icon]="{ name: SvgLibraryIcon.EDIT }"
          [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [size]="IconButtonSize.MEDIUM"
          [disabled]="updating"
          [title]="'CORPORATE.corporatePortal.editDetails' | finLocalization"
          [aria]="{
            label: 'CORPORATE.corporatePortal.editDetails' | finLocalization,
            loadingLabel: 'actions.loading' | finLocalization,
          }"
          (clickBtn)="editContactPersons()"
        >
        </fcom-icon-button>
      </div>
    </ng-container>
  </div>
  <div class="ms-xlarge-b">
    <table class="nordic-blue-100-border font-body-2 relative">
      <caption class="is-vishidden">
        {{
          'CORPORATE.corporatePortal.corporateDetails.contactPersons' | finLocalization
        }}
      </caption>
      <tbody class="dn-mobile">
        <tr>
          <th
            class="border-bottom ps-small-y ps-xsmall-x border-left border-top rounded-top-left-large light-type align-left"
            scope="row"
          >
            {{ 'CORPORATE.corporatePortal.corporateDetails.primaryContact.label' | finLocalization }}
          </th>
          <td class="border-top ps-small-y ps-xsmall-x border-bottom bold-type">{{ company.primaryAdmin.name }}</td>
          <td class="border-bottom ps-small-y ps-xsmall-x border-top border-right rounded-top-right-large">
            {{ company.primaryAdmin.email }}
          </td>
        </tr>
        <tr>
          <th
            class="border-bottom ps-small-y ps-xsmall-x border-left rounded-bottom-left-large light-type align-left"
            scope="row"
          >
            {{ 'CORPORATE.corporatePortal.corporateDetails.secondaryContact.label' | finLocalization }}
          </th>
          <td class="ps-small-y ps-xsmall-x border-bottom bold-type fixed-240">
            {{ company.secondaryAdmin?.name || '-' }}
          </td>
          <td class="border-bottom ps-small-y ps-xsmall-x border-right rounded-bottom-right-large">
            {{ company.secondaryAdmin?.email || '-' }}
          </td>
        </tr>
      </tbody>
      <tbody class="dn-tablet-up">
        <tr>
          <td class="border-bottom ps-small-y ps-xsmall-x border-left border-top border-right rounded-top-large">
            <div>{{ 'CORPORATE.corporatePortal.corporateDetails.primaryContact.label' | finLocalization }}</div>
            <div class="bold-type">{{ company.primaryAdmin.name }}</div>
          </td>
        </tr>
        <tr>
          <td class="border-bottom ps-small-y ps-xsmall-x border-left border-right rounded-bottom-large">
            <div>{{ 'CORPORATE.corporatePortal.corporateDetails.primaryContact.label' | finLocalization }}</div>
            <div class="bold-type">{{ company.secondaryAdmin?.name || '-' }}</div>
          </td>
        </tr>
      </tbody>
      <tbody
        *ngIf="updating && editFormType === EditFormType.CONTACT_PERSONS"
        class="absolute fill grow block top-left"
      >
        <tr class="absolute fill grow">
          <td class="absolute fill grow loader">
            <div class="grey-25-bg border fill grow rounded-large flex flex--center" data-testid="corporate-loader">
              <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex ms-medium-b">
    <div class="flex flex-1 flex--middle">
      <h4>{{ 'CORPORATE.corporatePortal.corporateDetails.agreementInformation' | finLocalization }}</h4>
    </div>
  </div>
  <div class="ms-xlarge-b">
    <fcom-table
      class="font-body-2"
      [rowData]="agreementDetailsData$ | async"
      [cellTemplate]="itemTemplate"
      [headerTemplate]="headerTemplate"
      [mobileTemplate]="mobileAgreementTemplate"
      [headers]="agreementDetailsHeaders"
      [usePagination]="false"
      [caption]="'CORPORATE.corporatePortal.corporateDetails.agreementInformation' | finLocalization"
    ></fcom-table>
  </div>

  @if (configService.cfg.enableCorporateSaf) {
    <div class="flex ms-medium-b">
      <div class="flex flex-1 flex--middle">
        <h4>{{ 'CORPORATE.corporatePortal.corporateDetails.partnerServices' | finLocalization }}</h4>
      </div>
    </div>
    <div class="ms-xlarge-b">
      <table class="font-body-2">
        <caption class="is-vishidden">
          {{
            'CORPORATE.corporatePortal.corporateDetails.partnerServices' | finLocalization
          }}
        </caption>
        <tr>
          <th
            scope="row"
            class="fixed-240 light-type align-left ps-medium-y ps-xsmall-x border-bottom border-top nordic-blue-100-border border-left rounded-left-large"
          >
            {{ 'CORPORATE.corporatePortal.corporateDetails.chooose.title' | finLocalization }}
          </th>
          <td class="border-bottom border-top nordic-blue-100-border ps-small-y ps-xsmall-x">
            @if (choooseRow$ | async; as tag) {
              <fcom-tag [theme]="tag.tagTheme" [disabled]="tag.tagDisabled">
                {{ tag.tagText | finLocalization }}
              </fcom-tag>
            }
          </td>
          <td
            class="border-top border-right border-bottom rounded-right-large nordic-blue-100-border ps-small align-right"
          >
            @if (isAdmin$ | async) {
              @if (safLoading) {
                <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
              } @else {
                <fcom-link
                  [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
                  (beforeNavigation)="goToChooose()"
                >
                  {{ (choooseRow$ | async)?.linkText | finLocalization }}
                </fcom-link>
              }
            }
          </td>
        </tr>
      </table>
    </div>
  }
</ng-container>

<ng-template #itemTemplate let-item>
  <div>
    <span *ngIf="!item.value && item.label">
      {{ 'CORPORATE.corporatePortal.corporateDetails.rows.' + item.label | finLocalization }}
    </span>
    <ng-container *ngTemplateOutlet="itemRenderer; context: { item }"></ng-container>
  </div>
</ng-template>
<ng-template #mobileTemplate let-item>
  <div>{{ 'CORPORATE.corporatePortal.corporateDetails.rows.' + item.label.data.label | finLocalization }}</div>
  <div class="bold-type">
    <ng-container *ngTemplateOutlet="itemRenderer; context: { item: item.value.data }"></ng-container>
  </div>
</ng-template>

<ng-template #mobileAgreementTemplate let-item>
  <div>
    {{ item.start.data.value | finDateFormat: 'DATE' }}
    -
    {{ item.end.data.value | finDateFormat: 'DATE' }}
  </div>
</ng-template>
<ng-template #loader>
  <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
</ng-template>
<ng-template #itemRenderer let-item="item">
  <ng-container *ngIf="item.value" [ngSwitch]="item.type">
    <span *ngSwitchCase="DataType.DATE">{{ item.value | finDateFormat: 'DATE' }}</span>
    <span *ngSwitchDefault>{{ item.value }}</span>
  </ng-container>
  <span *ngIf="!item.label && !item.value">-</span>
</ng-template>

<ng-template #headerTemplate let-item>
  {{ 'CORPORATE.corporatePortal.corporateDetails.rows.' + item.key | finLocalization }}
</ng-template>

<fcom-modal
  [title]="'CORPORATE.corporatePortal.corporateDetails.header' | finLocalization"
  [(open)]="openCompanyDetails"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [overlayClickable]="false"
  [fitToContent]="true"
  [confirmEnabled]="form?.valid"
  [confirmTranslationKey]="'actions.save'"
  (confirm)="updateCompany(EditFormType.COMPANY_DETAILS)"
>
  <div class="pr-large-x pr-medium-y" *ngIf="company$ | async as company">
    <table class="border rounded-large nordic-blue-100-border font-body-2 nowrap">
      <caption class="is-vishidden">
        {{
          'CORPORATE.corporatePortal.corporateDetails.header' | finLocalization
        }}
      </caption>
      <tbody>
        <tr>
          <th class="light-type border-bottom ps-small align-left">
            {{ 'CORPORATE.corporatePortal.corporateDetails.rows.name' | finLocalization }}
          </th>
          <td class="medium-type border-bottom">{{ company.name }}</td>
        </tr>
        <tr>
          <th class="light-type border-bottom ps-small align-left">
            {{ 'CORPORATE.corporatePortal.corporateDetails.rows.corporateNumber' | finLocalization }}
          </th>
          <td class="medium-type border-bottom">{{ company.clientId }}</td>
        </tr>
        <tr>
          <th class="light-type ps-small align-left">
            {{ 'CORPORATE.corporatePortal.corporateDetails.rows.businessId' | finLocalization }}
          </th>
          <td class="medium-type">{{ company.businessId }}</td>
        </tr>
      </tbody>
    </table>

    <div class="ms-medium-t">
      <fcom-text-input
        [parentForm]="form"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.address'"
        [controlName]="'address'"
        [displayMargin]="false"
      ></fcom-text-input>
      <div class="columns ms-medium-t">
        <fcom-text-input
          [parentForm]="form"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.postalCode'"
          [controlName]="'postalCode'"
        ></fcom-text-input>
        <fcom-text-input
          [parentForm]="form"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.city'"
          [controlName]="'city'"
        ></fcom-text-input>
      </div>
    </div>

    <table class="border rounded-large nordic-blue-100-border font-body-2 nowrap ms-large-b">
      <caption class="is-vishidden">
        {{
          'CORPORATE.corporatePortal.corporateDetails.header' | finLocalization
        }}
      </caption>
      <tbody>
        <tr>
          <th class="light-type ps-small align-left">
            {{ 'CORPORATE.corporatePortal.corporateDetails.rows.country' | finLocalization }}
          </th>
          <td class="medium-type">{{ company.country | finCountryName | async }}</td>
        </tr>
      </tbody>
    </table>

    <fcom-notification>
      {{ 'CORPORATE.corporatePortal.corporateDetails.contactUs' | finLocalization }}
    </fcom-notification>
  </div>
</fcom-modal>

<fcom-modal
  [title]="'CORPORATE.corporatePortal.corporateDetails.contactPersons' | finLocalization"
  [(open)]="openContactDetails"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [fitToContent]="true"
  [confirmEnabled]="contactPersonForm?.valid"
  [confirmTranslationKey]="'actions.save'"
  [overlayClickable]="false"
  (confirm)="updateContactPersons()"
>
  <div class="pr-large-x pr-medium-y" *ngIf="contactPersonForm">
    <div *ngIf="primaryContacts$ | async as primaryContacts; else loader">
      <fin-select-input
        [parentForm]="contactPersonForm"
        [controlName]="'primaryContact'"
        [options]="primaryContacts"
        [selectLabelTranslationKey]="'CORPORATE.corporatePortal.addUser.fields.role.placeholder'"
        [translationPrefix]="'CORPORATE.corporatePortal.corporateDetails.primaryContact'"
        (change)="setContactOptions()"
      ></fin-select-input>
    </div>
    <div *ngIf="secondaryContacts$ | async as secondaryContacts">
      <fin-select-input
        [parentForm]="contactPersonForm"
        [controlName]="'secondaryContact'"
        [options]="secondaryContacts"
        [selectLabelTranslationKey]="'CORPORATE.corporatePortal.addUser.fields.role.placeholder'"
        [translationPrefix]="'CORPORATE.corporatePortal.corporateDetails.secondaryContact'"
        (change)="setContactOptions()"
      ></fin-select-input>
    </div>
  </div>
</fcom-modal>

<fin-saf-terms
  #safTerms
  [hasSafPermission$]="hasActivatedSAF$"
  (termsUpdated)="termsUpdated()"
  (completed)="safLoading = false"
></fin-saf-terms>
